<script>
export default {
    name: 'IconSortReset',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-sort-reset"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M46.249 24v23.387l6.563-6.563L56 44 44 56 32 44l3.188-3.176 6.56 6.56V24h4.5zM20 8l12 12-3.188 3.176-6.564-6.563V40h-4.5V16.616l-6.56 6.56L8 20 20 8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
